"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_FORMAT = exports.eventListDefaultFilters = exports.emptyEventListPage = exports.defaultParams = exports.PROHIBITED_STATUSES_SSE_SUBSCRIPTION_LIST = exports.getParamsFetchTopLiveEvents = exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = exports.MAX_RECONNECTS_ATTEMPTS_SSE_EVENT_PROBABILITIES = exports.TIME_DELAY_RECONNECTION_SSE_EVENT_PROBABILITIES = exports.MAX_RECONNECTS_ATTEMPTS_SSE_TOP_EVENTS = exports.TIME_DELAY_RECONNECTION_SSE_TOP_EVENTS = exports.SOURCE_KEY_EVENT_PROBABILITY_SSE = exports.SSE_TOP_EVENT_UPDATED_VALUES = exports.SSE_TOP_EVENT_UPDATE_IGNORED_KEYS = void 0;
const types_1 = require("../../utils/api/types");
exports.SSE_TOP_EVENT_UPDATE_IGNORED_KEYS = [
    'probabilities',
    'outcomesCount',
    'statistics',
];
exports.SSE_TOP_EVENT_UPDATED_VALUES = [
    'event',
    'probabilities',
    'statistics',
];
exports.SOURCE_KEY_EVENT_PROBABILITY_SSE = 'sourceKeyEventProbabilitySSE';
exports.TIME_DELAY_RECONNECTION_SSE_TOP_EVENTS = 1000;
exports.MAX_RECONNECTS_ATTEMPTS_SSE_TOP_EVENTS = 5;
exports.TIME_DELAY_RECONNECTION_SSE_EVENT_PROBABILITIES = 1000;
exports.MAX_RECONNECTS_ATTEMPTS_SSE_EVENT_PROBABILITIES = 5;
exports.DEFAULT_PAGE_SIZE = 20;
exports.MAX_PAGE_SIZE = 200;
const getParamsFetchTopLiveEvents = (params) => ({
    reqData: {
        live: true,
        top: true,
        ...params,
    },
});
exports.getParamsFetchTopLiveEvents = getParamsFetchTopLiveEvents;
exports.PROHIBITED_STATUSES_SSE_SUBSCRIPTION_LIST = [
    types_1.EEventMessageSSEType.CLOSED,
    types_1.EEventMessageSSEType.ERROR,
];
exports.defaultParams = {
    withCompetitorsLogo: true,
    withLinkedEvents: false,
};
exports.emptyEventListPage = {
    loading: false,
    polling: false,
    eventIds: [],
    paginationKeyBackward: undefined,
    paginationKeyForward: undefined,
    paginationKey: undefined,
    paginationKeyDirection: undefined,
};
exports.eventListDefaultFilters = {};
exports.DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
//# sourceMappingURL=constants.js.map